import { CreditCard, Layers, Package, ShoppingCart } from "lucide-react";
import type { SideTab } from "@/components/shared";
import { BvReport, PaymentsReport, ProductsReport, SalesReport } from "./storeReports";

/** Store reports. Add an entry to give it a tab and a URL (/store/reports/<id>). */
export const storeReports: SideTab[] = [
  { id: "sales", label: "Sales Report", icon: ShoppingCart, render: () => <SalesReport /> },
  { id: "payments", label: "Payment Report", icon: CreditCard, render: () => <PaymentsReport /> },
  { id: "bv", label: "BV Report", icon: Layers, render: () => <BvReport /> },
  { id: "products", label: "Product Report", icon: Package, render: () => <ProductsReport /> },
];
